import { CalendarDays, Clock, CloudSun, ListChecks, Newspaper, type LucideIcon } from 'lucide-react';

/** The widgets, each with its own settings page under Settings → Widgets. Ids are also settings keys. */
export type WidgetPageId = 'clock' | 'weather' | 'calendar' | 'lists' | 'news';

export const WIDGET_PAGES: Array<{ id: WidgetPageId; name: string; icon: LucideIcon }> = [
  { id: 'clock', name: 'Clock', icon: Clock },
  { id: 'weather', name: 'Weather', icon: CloudSun },
  { id: 'calendar', name: 'Calendar', icon: CalendarDays },
  { id: 'lists', name: 'To-do lists', icon: ListChecks },
  { id: 'news', name: 'News', icon: Newspaper },
];
